<template>
  <div>
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
    <div class="content_box">
      <el-row v-if="isMy" style="margin:5px 0">
        <el-button size="mini" class="btn" type="primary" @click="onAddSave" v-acl="RMC_PROT_FEEDPLANT_SAVE" v-if="rmcProteinFeedFactoryId==='0'&&(!detailForm.auditStatus||detailForm.auditStatus==='Draft')&&(ms_roles.indexOf('QSPI_RMC_CHICK_SPONS_SUPP')!==-1||ms_roles.indexOf('QSPI_RMC_PORK_SPONS_SUPP')!==-1)">保存</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onEditSave" v-acl="RMC_PROT_FEEDPLANT_SAVE" v-if="rmcProteinFeedFactoryId!=='0'&&(!detailForm.auditStatus||detailForm.auditStatus==='Draft')&&(ms_roles.indexOf('QSPI_RMC_CHICK_SPONS_SUPP')!==-1||ms_roles.indexOf('QSPI_RMC_PORK_SPONS_SUPP')!==-1)">保存</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onSubmit" v-acl="RMC_PROT_FEEDPLANT_SUBMIT" v-if="detailForm.auditStatus!=='PendingApproval'&&(ms_roles.indexOf('QSPI_RMC_CHICK_SPONS_SUPP')!==-1||ms_roles.indexOf('QSPI_RMC_PORK_SPONS_SUPP')!==-1)">提交</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onApprove" v-acl="RMC_PROT_FEEDPLANT_APPROVE" v-if="detailForm.auditStatus==='PendingApproval'&&ms_roles.indexOf('QSPI_RMC_PROTEIN_CQS')!==-1">批准</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onReturn" v-acl="RMC_PROT_FEEDPLANT_RETURN" v-if="detailForm.auditStatus==='PendingApproval'&&ms_roles.indexOf('QSPI_RMC_PROTEIN_CQS')!==-1">退回</el-button>
      </el-row>
      <el-form :model="detailForm" ref="detailForm" label-width="120px">
        <div class="within_box">
          <div class="title_box">
            <p class="line"></p>
            <p class="title">饲料厂清单</p>
          </div>
          <div class="form_box">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="Category3" prop="category3Code">
                  <el-select v-model="detailForm.category3Code" :disabled="isDisabled||isForbidden" placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in category3CodeOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Sponsor" prop="sponsorName">
                  <el-input v-model="detailForm.sponsorName" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="ASL Group" prop="aslGroupCode" :rules="rules.aslGroupCode" class="is-required">
                  <el-select v-model="detailForm.aslGroupCode" clearable :disabled="isForbidden" placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in aslGroupCodeOptions" :label="item.aslGroupName" :value="item.aslGroupCode" :disabled="!item.enabled"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态" prop="auditStatus">
                  <el-select v-model="detailForm.auditStatus" disabled placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in auditStatusOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="饲料厂名称" prop="feedFactoryName" :rules="rules.feedFactoryName" class="is-required">
                  <el-input v-model="detailForm.feedFactoryName" :disabled="isForbidden" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="地址" prop="feedFactoryAddress" :rules="rules.feedFactoryAddress" class="is-required">
                  <el-input v-model="detailForm.feedFactoryAddress" :disabled="isForbidden" clearable placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="饲料厂属性" prop="feedFactoryNature" :rules="rules.feedFactoryNature" class="is-required">
                  <el-select v-model="detailForm.feedFactoryNature" :disabled="isForbidden" clearable placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in feedFactoryNatureOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="饲料厂状态" prop="factoryStatus" :rules="rules.factoryStatus" class="is-required">
                  <el-select v-model="detailForm.factoryStatus" :disabled="isForbidden" clearable placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in factoryStatusOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="审核标准" prop="auditStandard" class="is-required" :rules="rules.auditStandard">
                  <el-input v-model="detailForm.auditStandard" :disabled="isForbidden" placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="$route.query.from === 'edit'">
              <el-col :span="24">
                <el-form-item label="上次修改原因" prop="lastUpdateReason">
                  <el-input v-model="lastUpdateReason" disabled type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="修改原因" prop="updateReason" class="is-required" :rules="rules.updateReason">
                  <el-input v-model="detailForm.updateReason" :disabled="isForbidden" type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
    </div>
    <el-dialog title="退回意见" :visible.sync="dialogReturnVisible" width="30%" :close-on-click-modal="false" @close="onClose" class="fpa">
      <el-form ref="returnForm" :model="returnForm" :rules="returnFormRules">
        <el-form-item prop="returnedReason">
          <el-input v-model="returnForm.returnedReason" type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="center">
        <el-button size="mini" @click="onConfirm" type="primary">确定</el-button>
        <el-button size="mini" @click="onClose">取消</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import rmcProtFeedPlantApi from "@/api/rmcProtein/feedPlant";
export default {
  name: "rmcProtfarmNameDetail",
  components: {
    IcSelect,
  },
  data() {
    return {
      rules: {
        aslGroupCode: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请选择ASL Group')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        feedFactoryName: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请输入饲料厂名称')
                return callback(new Error(' '));
              };
              var reg = /^.{1,100}$/
              if (!reg.test(value)) {
                this.$message.error('字段“饲料厂名称”已超出数据库长度要求（长度：100），请删减.')
                return callback(new Error(' '));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        feedFactoryAddress: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请输入地址')
                return callback(new Error(' '));
              };
              var reg = /^.{1,100}$/
              if (!reg.test(value)) {
                this.$message.error('字段“地址”已超出数据库长度要求（长度：100），请删减.')
                return callback(new Error(' '));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        feedFactoryNature: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请选择饲料厂属性')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        factoryStatus: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请选择饲料厂状态')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        auditStandard: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请输入审核标准')
                return callback(new Error(' '));
              };
              var reg = /^.{1,100}$/
              if (!reg.test(value)) {
                this.$message.error('字段“审核标准”已超出数据库长度要求（长度：100），请删减.')
                return callback(new Error(' '));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        updateReason: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请输入修改原因')
                return callback(new Error(' '));
              };
              var reg = /^.{1,1000}$/
              if (!reg.test(value)) {
                this.$message.error('字段“修改原因”已超出数据库长度要求（长度：1000），请删减.')
                return callback(new Error(' '));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
      },
      detailForm: {},
      returnForm: {
        returnedReason: "",
      },
      returnFormRules: {
        returnedReason: [
          { required: true, message: '请输入退回意见', trigger: 'blur' },
        ],
      },
      tableData: [],
      fileList: [],
      category3CodeOptions: [],
      aslGroupCodeOptions: [],
      auditStatusOptions: [],
      feedFactoryNatureOptions: [],
      factoryStatusOptions: [],
      rmcProteinFeedFactoryIds: [],
      isDisabled: true,
      isForbidden: false,
      dialogReturnVisible: false,
      ms_roles: null,
      ms_Permission: null,
      supplierObj: null,
      rmcProteinFeedFactoryId: "",
      lastUpdateReason:"",

      isMy: true,
    }
  },
  created() {
    this.ms_roles = JSON.parse(localStorage.getItem('ms_roles'))
    this.ms_Permission = JSON.parse(localStorage.getItem('ms_Permission'))
    this.supplierObj = JSON.parse(localStorage.getItem("supplierObj"));
    this.rmcProteinFeedFactoryId = this.$route.query.rmcProteinFeedFactoryId
    if (this.$route.query.from === 'edit') {
      if (this.$route.query.rmcProteinFeedFactoryId) {
        this.rmcProteinFeedFactoryIds.push(this.$route.query.rmcProteinFeedFactoryId)
      }
      this.getDetailInfo()
    } else {
      this.$set(this.detailForm, 'auditStatus', 'Draft')
      this.getSponsorByUser()
      this.getAuthorizedCategory3()
    }
    this.getSelection()
  },
  mounted() {

  },
  methods: {
    getDetailInfo() {
      rmcProtFeedPlantApi.getDetailInfo(this.$route.query.rmcProteinFeedFactoryId).then(res => {
        console.log('获取明细', res);
        this.detailForm = res.data
        this.rmcProteinFeedFactoryId = res.data.rmcProteinFeedFactoryId
        this.lastUpdateReason=res.data.updateReason
        this.detailForm.updateReason=""
        if (res.data.auditStatus !== 'PendingApproval' && (this.ms_Permission.indexOf('RMC_PROT_FEEDPLANT_SAVE') !== -1 || this.ms_Permission.indexOf('RMC_PROT_FEEDPLANT_SUBMIT') !== -1)) {
          this.isForbidden = false
        } else {
          this.isForbidden = true
        }
        if(this.supplierObj.supperSupplierCode != res.data.sponsorCode) {
          this.isForbidden = true
          this.isMy = false;
        }
        this.getAslGroupList(res.data.sponsorCode, res.data.aslGroupCode);
      });
    },
    getSponsorByUser() {
      rmcProtFeedPlantApi.getSponsorByUser().then(res => {
        console.log('获取Sponsor', res);
        this.detailForm.sponsorName = res.data.supplierName
        this.detailForm.sponsorCode = res.data.supplierCode
        if (this.$route.query.from === 'add') {
          this.getAslGroupList(res.data.supplierCode);
        }
      });
    },
    getAuthorizedCategory3() {
      rmcProtFeedPlantApi.getAuthorizedCategory3(this.$route.query.rmcProteinFeedFactoryId).then(res => {
        console.log('获取category3', res);
        this.category3CodeOptions = res.data.filter((v) => {
          return v.cascadeKey === 'protein'
        })
        if (res.data.length === 1) {
          this.detailForm.category3Code = res.data[0].key
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      });
    },
    getSelection() {
      rmcProtFeedPlantApi.getSelection(['rmc.RmcCategory3', 'rmc.RmcAuditStatus', 'rmc.RmcFeedFactoryConstants:RmcFeedFactoryNature', 'rmc.RmcProteinFarmStatus']).then(res => {
        console.log('获取下拉框', res);
        this.category3CodeOptions = res.data['rmc.RmcCategory3'].filter((v) => {
          return v.cascadeKey === 'protein'
        })
        this.feedFactoryNatureOptions = res.data['rmc.RmcFeedFactoryConstants:RmcFeedFactoryNature'];
        this.factoryStatusOptions = res.data['rmc.RmcProteinFarmStatus'];
        this.auditStatusOptions = res.data['rmc.RmcAuditStatus'];
      });
    },
    getAslGroupList(sponsor, aslGroupCode) {
      console.log('aslGroupCode', aslGroupCode);
      rmcProtFeedPlantApi.getAslGroupList(sponsor).then(res => {
        console.log('获取ASL Group', res);
        this.aslGroupCodeOptions = res.data
        var codeLists = res.data.map(ele => {
          return ele.aslGroupCode
        })
        console.log('codeLists', codeLists);
        if (aslGroupCode&&!codeLists.includes(aslGroupCode)) {
          this.aslGroupCodeOptions.push({
            aslGroupCode: this.detailForm.aslGroupCode,
            aslGroupName: this.detailForm.aslGroupName,
            enabled: false,
            sponsorCode: sponsor,
          })
        }
        console.log('this.aslGroupCodeOptions', this.aslGroupCodeOptions);
      });
    },
    onAddSave() {
      this.$refs['detailForm'].validate((valid) => {
        if (valid) {
          var obj = {
            category3Code: this.detailForm.category3Code,
            sponsorCode: this.detailForm.sponsorCode,
            aslGroupCode: this.detailForm.aslGroupCode,
            feedFactoryName: this.detailForm.feedFactoryName,
            feedFactoryAddress: this.detailForm.feedFactoryAddress,
            feedFactoryNature: this.detailForm.feedFactoryNature,
            auditStandard: this.detailForm.auditStandard,
            factoryStatus: this.detailForm.factoryStatus,
            updateReason: this.detailForm.updateReason
          }
          rmcProtFeedPlantApi.addReq(obj).then(res => {
            console.log('保存', res);
            if (res.meta.code === 200) {
              this.$message.success('保存成功')
              this.$router.push('/rmcProtFeedPlant')
            } else {
              this.$message.error(res.meta.msg)
            }
          })
        }
      })
    },
    onEditSave() {
      this.$refs['detailForm'].validate((valid) => {
        if (valid) {
          var obj = {
            category3Code: this.detailForm.category3Code,
            sponsorCode: this.detailForm.sponsorCode,
            aslGroupCode: this.detailForm.aslGroupCode,
            feedFactoryName: this.detailForm.feedFactoryName,
            feedFactoryAddress: this.detailForm.feedFactoryAddress,
            feedFactoryNature: this.detailForm.feedFactoryNature,
            auditStandard: this.detailForm.auditStandard,
            factoryStatus: this.detailForm.factoryStatus,
            updateReason: this.detailForm.updateReason
          }
          rmcProtFeedPlantApi.updateReq(this.rmcProteinFeedFactoryId, obj).then(res => {
            console.log('更新', res);
            if (res.meta.code === 200) {
              this.$message.success('保存成功')
              this.$router.push('/rmcProtFeedPlant')
            } else {
              this.$message.error(res.meta.msg)
            }
          })
        }
      })
    },
    onSubmit() {
      this.$refs['detailForm'].validate((valid) => {
        if (valid) {
          var obj = {
            category3Code: this.detailForm.category3Code,
            sponsorCode: this.detailForm.sponsorCode,
            aslGroupCode: this.detailForm.aslGroupCode,
            feedFactoryName: this.detailForm.feedFactoryName,
            feedFactoryAddress: this.detailForm.feedFactoryAddress,
            feedFactoryNature: this.detailForm.feedFactoryNature,
            auditStandard: this.detailForm.auditStandard,
            factoryStatus: this.detailForm.factoryStatus,
            updateReason: this.detailForm.updateReason
          }
          rmcProtFeedPlantApi.submitReq(this.rmcProteinFeedFactoryId, obj).then(res => {
            if (res.meta.code === 200) {
              this.$message.success('提交成功')
              this.$router.push('/rmcProtFeedPlant')
            } else {
              this.$message.error(res.meta.msg)
            }
          })
        }
      })
    },
    onApprove() {
      rmcProtFeedPlantApi.approveReq({
        rmcProteinFeedFactoryIds: this.rmcProteinFeedFactoryIds
      }).then(res => {
        if (res.meta.code === 200) {
          this.$message.success('批准成功')
          this.$router.push('/rmcProtFeedPlant')
        } else {
          this.$message.error(res.meta.msg)
        }
      })
    },
    onReturn() {
      this.dialogReturnVisible = true
    },
    onConfirm() {
      this.$refs['returnForm'].validate((valid) => {
        if (valid) {
          rmcProtFeedPlantApi.returnReq({
            rmcProteinFeedFactoryIds: this.rmcProteinFeedFactoryIds,
            returnedReason: this.returnForm.returnedReason
          }).then(res => {
            if (res.meta.code === 200) {
              this.$message.success('退回成功')
              this.onClose()
              this.$router.push('/rmcProtFeedPlant')
            } else {
              this.$message.error(res.meta.msg)
            }
          })
        }
      })
    },
    onClose() {
      this.dialogReturnVisible = false
      this.returnForm.returnedReason = ''
    },
    routerBack() {
      this.$router.go(-1)
    },
  },
}
</script>

<style>
</style>